/** The category of the doc being viewed, so the sidebar can highlight it. */
import { create } from 'zustand';

export const useDocContext = create<{ category: string | null; set: (c: string | null) => void }>((set) => ({
  category: null,
  set: (category) => set({ category }),
}));

/** Seeded docs are authored by "seed"; show something meaningful instead. */
export const authorLabel = (by: string | null | undefined): string =>
  !by ? 'unknown' : by === 'seed' ? 'starter content' : by;
